import { useEffect, useState } from 'react'
import { onSwUpdateFlagged } from '../lib/swUpdate'

/* Flags a forced update to the user for the brief window between a new
 * service worker taking control and swUpdate.ts's automatic reload - see
 * that file for why this can't be deferred or dismissed. */
export default function UpdateBanner() {
  const [updating, setUpdating] = useState(false)

  useEffect(() => onSwUpdateFlagged(() => setUpdating(true)), [])

  if (!updating) return null

  return (
    <div role="status" aria-live="polite" style={{
      position: 'fixed', insetInline: 0, top: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--sp-3)',
      padding: 'var(--sp-3) var(--sp-4)',
      // Fixed brand colors rather than theme tokens - this is a system-level
      // notice shown for a fraction of a second before a reload, not themed
      // page content, and needs guaranteed contrast in either theme.
      background: '#1b3a2b', color: '#fff',
      fontSize: 'var(--text-sm)', fontWeight: 600,
    }}>
      <span className="spinner" aria-hidden style={{
        width: 14, height: 14, borderRadius: '50%',
        border: '2px solid currentColor', borderTopColor: 'transparent',
        animation: 'ssm-spin 0.7s linear infinite',
      }} />
      Updating to the latest version…
      <style>{'@keyframes ssm-spin { to { transform: rotate(360deg) } }'}</style>
    </div>
  )
}
